/**
 * @generated SignedSource<<4a2b3f9ad8e6647994aec6ede3345b66>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateModuleRatingInput = {
  clientMutationId?: string | null;
  message: string;
  nodeRef: string;
  value: number;
};
export type moduleRating_createModuleRatingSubmissionMutation$variables = {
  input: CreateModuleRatingInput;
};
export type moduleRating_createModuleRatingSubmissionMutation$data = {
  readonly ModuleRating: {
    readonly createModuleRating: {
      readonly edge: {
        readonly node: {
          readonly id: string;
          readonly value: number;
        };
      };
    } | null;
  };
};
export type moduleRating_createModuleRatingSubmissionMutation = {
  response: moduleRating_createModuleRatingSubmissionMutation$data;
  variables: moduleRating_createModuleRatingSubmissionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ModuleRatingMutations",
    "kind": "LinkedField",
    "name": "ModuleRating",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "CreateModuleRatingPayload",
        "kind": "LinkedField",
        "name": "createModuleRating",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ModuleRatingTypesEdge",
            "kind": "LinkedField",
            "name": "edge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ModuleRating",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "moduleRating_createModuleRatingSubmissionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "moduleRating_createModuleRatingSubmissionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "15ef488d60838e993678b74db3bd1a56",
    "id": null,
    "metadata": {},
    "name": "moduleRating_createModuleRatingSubmissionMutation",
    "operationKind": "mutation",
    "text": "mutation moduleRating_createModuleRatingSubmissionMutation(\n  $input: CreateModuleRatingInput!\n) {\n  ModuleRating {\n    createModuleRating(input: $input) {\n      edge {\n        node {\n          id\n          value\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "44e1e0162cb48b06fa768bbc3cb6d217";

export default node;
